<template>
  <div class="wrap">
    <div class="modal" v-click-outside="closeModal">
      <button class="close" @click="closeModal">
        <CloseIcone></CloseIcone>
      </button>
      <h1 class="privacy-header">Privacy Policy</h1>
      <div class="wrapper" v-for="(role, index) of rules">
        <div class="theme">
          <span>{{ index + 1 }}.</span>
          <span class="line">{{ role.theme }}</span>
        </div>
        <div class="title">
          {{ role.title }}
        </div>
        <div class="text" v-for="text of role.text">
          {{ text.main }}
          <div class="block" v-if="text.sub">
            <span class="text sub line">{{ text.sub }}</span>
          </div>
          <div class="dots" v-if="text.dots" v-for="dot of text.dots">
            <span class="dot">-</span><span>{{ dot }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcone from "../../images/shared/cancel";
export default {
  name: "Privacy",
  methods: {
    closeModal() {
      this.$emit("showPrivecy", false);
    }
  },
  components: {
    CloseIcone
  },
  data() {
    return {
      rules: [
        {
          theme: "Introduction",
          text: [
            {
              main: `MycoLab USA, Inc (“GOT MOLD?”) is dedicated to protecting your personal information. This Privacy Policy applies to your use of www.gotmold.com and the GOT MOLD? software, applications, components, and GOT MOLD? Services (collectively the “Platform”). Our Privacy Policy discloses our privacy practices and explains to you how we use, collect, store, transfer, and share your personal information. Please review this Privacy Policy periodically as we may revise it from time to time, without notice. If you do not agree with or accept our Privacy Policy in its entirety, you must not access or use the Platform.  Where any term is not defined in our Privacy Policy such term shall be defined in our Terms of Use.`
            }
          ]
        },
        {
          theme: "Information Collected",
          title: `What This Means:  We collect both personal and non-personal information from you when you use our Platform.`,
          text: [
            {
              main: `Personal information means any information about an individual from which that person can be identified. It does not include data where the identity has been removed or otherwise anonymized.`,
              sub: `Personal Information Collected from Users`
            },
            {
              main: `You will not be required to provide us with any personal information when you visit the Platform.  However, portions of our Platform may require us to collect personal information about you.  During your use of the Platform we may collect your name, email, address, telephone number, username, password, order information, and other identifying details.  Any personal information you submit via the Platform shall be used and disclosed in accordance with this Privacy Policy.   We may also collect payment information that you make available to us for your use of the Platform.   Please be aware that this payment information shall be stored by third-party payment processors.`,
              sub: `Non-Identifiying Information Automatically Collected`
            },
            {
              main: `Whenever you use our Platform, we may collect non-identifying information from you, such as your IP address, date/time-zone, interactions with the Platform, query information, location information, referring URL, browser, application interaction, mobile provider information, operating system, data usage, data transferred, and Internet Service Provider.  `
            }
          ]
        },
        {
          theme: "Anonymized Data",
          title: `What This Means:  We may anonymize any personal information collected for our internal research purposes.`,
          text: [
            {
              main: `Please be aware that we me may collect and aggregate personal information from our Platform and may anonymize that information for our own research or internal purposes.  Once such data has been anonymized, it cannot be traced back to you, the user.`
            }
          ]
        },
        {
          theme: "Sharing and Use of Your Information",
          title: `What This Means:  We may share your personal information for the following purposes: contract administration, communications, use of the Platform, to share with third parties, for direct responses, downloads, as required for legal purposes, and direct marketing.`,
          text: [
            {
              main: `This section explains how GOT MOLD? may share or use your personal information. You consent to our use of your personal information for the following purposes:`,
              dots: [
                `CONTRACT ADMINISTRATION -  We may use your personal information to negotiate, execute, renew and/or manage a contract with you.`,
                `ACCESS AND COMMUNICATIONS TO OUR PLATFORM AND SERVICES - We may use your personal information to (1) set-up and manage your GOT MOLD? account; (2) interact with you through our Platform (e.g. software updates, Platform announcements, etc.): and/or (3) manage and respond to your questions (e.g. technical, commercial or administrative) or requests for maintenance and support.`,
                `USE OF THE PLATFORM - We may use your personal information to (1) enable you to enjoy the use of, and easily navigate the Platform; and/or (2) better understand your needs and interests.`,
                `SHARING WITH THIRD PARTIES - We may use your personal information to share with our third-party marketing partners. We may also share your information with service providers with whom we contract with such as contractors, payment providers, web hosts, data providers, laboratories, and others so that we may provide you any services and allow you to access the Platform. Please be aware that we will not share any of your lab data or testing results with any third parties except for contractors that assist us in providing the GOT MOLD? Services.`,
                `ALLOWING DOWNLOADS FROM THE PLATFORM - We may use your personal information to allow you to download the Platform or to download data or content from the Platform.`,
                `TRAINING & IMPROVEMENTS - We may use your personal information to (1) train our employees or contractors to allow for a better Platform experience; and/or (2) improve the Platform.`,
                `DIRECT MARKETING AND INQUIRIES - We may use your personal information to contact you for additional products and services that you may be interested in or to respond to an inquiry. `,
                `LEGAL PROCESS - We may share your information: if we believe that disclosure is reasonably necessary to comply with a law, regulation, legal or governmental request; to respond to a subpoena, court order, warrant, or other legal process; to enforce applicable Terms of Use or this Privacy Policy, including investigation of potential violations thereof; to protect the safety, rights, or property of the public, any person, or GOT MOLD?; to detect, prevent, or otherwise address security, technical issues, or illegal or suspected illegal activities (including fraud); or as evidence in litigation in which we are involved, as part of a judicial or regulatory proceeding.`
              ]
            }
          ]
        },
        {
          theme: "Retention of Personal Information",
          title: `What This Means: We may retain your personal information for legal purposes or as required by us, until you request that we delete or remove your information.`,
          text: [
            {
              main: `GOT MOLD? will only retain your Personal Information for as long as required. We will keep your personal information:`,
              dots: [
                `For any legally required duration or as required based on our internal data retention policies `,
                `Until we receive a request to eliminate, delete, or modify any of your personal information stored with us, subject to our legal obligations.`
              ]
            }
          ]
        },
        {
          theme: "Accessing and Editing Your Information",
          title: `What This Means: You may access your personal information via the Platform, if you have any questions please contact us.`,
          text: [
            {
              main: `When using our Platform you may be able to access and edit some of your personal information via the Platform dashboard.  If at any time, you have any questions or wish to review, change, or edit any additional personal information collected by us, please contact us at help@gotmold.com. `
            }
          ]
        },
        {
          theme: "Removal of Information",
          title: `What This Means: If you wish to remove any personal information from the Platform please contact us.`,
          text: [
            {
              main: `If you wish to have any of your personal information removed, please contact us at help@gotmold.com. Please be aware that removal requests are not processed instantaneously. There may be a reasonable delay in removing any personal information requested.`
            },
            {
              main: `If you require additional details regarding the deletion or retention of your personal information, please contact us.  All removal or deletion requests are subject to Section 5 and subject to any applicable laws.  Additionally, we will retain and use your personal information (even after a removal or deletion request), where required, so that we may fulfill our legal obligations, resolve disputes, and enforce our agreements.`
            }
          ]
        },
        {
          theme: "Cookies ",
          title: `What This Means: We may use cookies to assist you in using the Platform.`,
          text: [
            {
              main: `We currently may use cookies to understand how you use our Platform, to remember you, and to provide you with the best possible marketing experience.  If you do not wish to have cookies loaded on your browser, please adjust your browser settings.  Please be aware that disabling cookies may cause some issues with the functionality of our Platform.`
            }
          ]
        },
        {
          theme: "Opting Out and Do Not Track",
          title: `What This Means:  We may send you communications via text or email until you opt out.`,
          text: [
            {
              main: `If you decide to provide us with your contact information, you agree that we may send you communications via text and email where you have consented.  However, you may opt out of any communications and you may opt out of certain personal information submission where applicable.  If you wish to opt out of certain communications or information collection, please do so via the Platform dashboard.  `
            },
            {
              main: `We currently do not offer website functionality for you to opt out of any “do not track” signals or listings. `
            }
          ]
        },
        {
          theme: "Third Parties",
          title: `What This Means:  Please exercise caution when visiting any third-party websites via our Platform.`,
          text: [
            {
              main: `GOT MOLD?, or its users, may post links to third party websites on our Platform, which may include information that we have no control over.  When accessing a third-party site through our Platform, you acknowledge that you are aware that these third party websites are not screened for privacy or security issues by us. GOT MOLD? bears no responsibility for the information collected or used by any advertiser or third-party website that you have visited through a link on our Platform. You must review that third party’s Terms of Service and Privacy Policy to understand how their information collection practices work.`
            }
          ]
        },
        {
          theme: "Security Measures",
          title: `What This Means: We use both physical and electronic safeguards to protect your personal information.`,
          text: [
            {
              main: `We make reasonable attempts to protect your personal information by using physical and electronic safeguards. We currently employ SSL certificates to assist us in securing our Platform. However, as our Platform is hosted electronically we can make no guarantees as to the security or privacy of your information.  For this reason, we recommend that you use anti-virus software, robust passwords, firewalls, and other precautions to protect yourself from security and privacy threats.`
            }
          ]
        },
        {
          theme: "Your California Privacy Rights",
          title: `What This Means: If you are a California resident you may request additional information from us regarding marketing activities.`,
          text: [
            {
              main: `GOT MOLD? permits residents of the State of California to use its Platform, and complies with the California Business and Professions Code §§ 22575-22579.  If you are a California resident you may request certain information regarding our disclosure of personal information to any third parties for their direct marketing purposes.  Various provisions throughout this Privacy Policy address requirements of the Californian privacy statutes. Although we do not disseminate your information to third parties without permission, you must presume that we collect electronic information from all visitors. You may contact us at help@gotmold.com with any questions regarding your California Privacy Rights.`
            }
          ]
        },
        {
          theme: "Age Compliance",
          title: `What This Means: We do not collect any personal information from people under the age of 18.`,
          text: [
            {
              main: `We intend to fully comply with American and international laws respecting children’s privacy.  Therefore, we do not collect or process any information for any persons under the age of 18.  If you are under 18 you may not access the Platform.`
            }
          ]
        },
        {
          theme: "Transfer of Your Information Internationally",
          title: `What This Means: Your personal information may be stored in the US.`,
          text: [
            {
              main: `If you are not a citizen of the United States please be aware that your personal information shall be transferred and processed in the United States. These data transfers are necessary to provide the Platform to you.`
            }
          ]
        },
        {
          theme: "Merger and Acquisition",
          title: `What This Means: Where we are acquired your personal information may be transferred to a third party.`,
          text: [
            {
              main: `In the event that GOT MOLD? is involved in a bankruptcy, merger, acquisition, reorganization or sale of assets, your personal information may be sold or transferred as part of that transaction. Please be aware that once the information is transferred your privacy rights may change.`
            }
          ]
        },
        {
          theme: "Amendments",
          title: `What This Means: We may amend this Privacy Policy from time to time.`,
          text: [
            {
              main: `Like our Terms of Use, we may amend this Privacy Policy at any time without notice.  When we amend this Privacy Policy, we will modify the date listed on this Agreement or we may contact you.  You must agree to the amendments as a condition of your continued use of our Platform.  If you do not agree, you must immediately cease using our Platform and notify us of your refusal to agree by e-mailing us at help@gotmold.com.`
            }
          ]
        },
        {
          theme: "Contacting Us",
          text: [
            {
              main: `If you have any additional questions, please contact us at help@gotmold.com`
            }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}
.wrap {
  width: 100vw;
  height: 100vh;
  max-width: 100%;
  max-height: 100%;
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal {
  border-radius: 10px;
  height: 750px;
  width: 1040px;
  overflow: auto;
  background-color: #fff;
  padding: 20px;
  font-size: 15px;
  position: relative;
}
.theme {
  font-size: 16px;
  font-family: TTNormsBold, sans-serif;
  margin: 0 0 10px 0;
}
.theme span {
  padding: 0 10px 0px 0;
}
.title {
  font-size: 15px;
  font-family: TTNormsMedium, sans-serif;
  margin: 10px 0 10px 0;
}
.text {
  font-size: 14px;
  line-height: 1.3;
  font-family: TTNormsRegular, sans-serif;
  margin: 0 0 10px 0;
}
.privacy-header {
  font-size: 18px;
  font-family: TTNormsBold, sans-serif;
  margin: 0 0 10px 0;
  text-align: center;
  margin: 10px 0 30px;
}
.dots {
  padding: 5px;
}
.dot {
  padding: 0 5px;
}
.line {
  border-bottom: 1px solid black;
}
.text.sub {
  margin: 20px 0 0px 30px;
  padding: 20px 0 0 0;
}
.block {
  margin: 20px 0 0px 0;
}
@media (max-height: 790px) {
  .modal {
    height: 690px;
  }
}
</style>
